export default __webpack_public_path__ + "static/media/Neuroshiled-volumetry.d5596e22.png";